import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
  "relative inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-focus-ring focus-visible:ring-focus-ring/50 focus-visible:ring-[3px] aria-invalid:ring-error/20 dark:aria-invalid:ring-error/40 aria-invalid:border-error cursor-pointer",
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-fg hover:bg-primary-hover active:bg-primary-active',
        destructive:
          'bg-error text-error-fg hover:bg-error-hover focus-visible:ring-error/20 dark:focus-visible:ring-error/40',
        outline:
          'border border-border-default bg-bg-base text-text-secondary hover:bg-bg-subtle hover:text-text-primary dark:bg-transparent',
        secondary:
          'bg-secondary text-secondary-fg hover:bg-secondary-hover active:bg-secondary-active',
        ghost:
          'text-text-secondary hover:bg-bg-muted hover:text-text-primary dark:hover:bg-bg-muted/40',
        link: 'text-primary underline-offset-4 hover:underline',
        neutral: 'bg-bg-muted text-text-secondary hover:bg-bg-subtle dark:bg-bg-muted/20',
      },
      size: {
        default: 'h-11 md:h-9 px-4 py-2 has-[>svg]:px-3',
        sm: 'h-10 md:h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5',
        md: 'h-12 md:h-11 px-3 py-2 gap-2 font-normal',
        lg: 'h-12 md:h-10 rounded-md px-6 has-[>svg]:px-4',
        icon: 'size-11 md:size-9',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)
